import React, { useEffect, useState ,useContext} from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_PATH } from ".././../constants/Global";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import DataService from ".././../services/tutorial.service";
import { catlistData ,actlistData,setisfirsttime} from "../../actions/index";
import ColorPicker from "../team/ColorPicker";
import { getDatabase, ref, remove, onValue, set, update } from "firebase/database";
import { FirebaseContext } from '../../FirebaseContext';

function Addcategory(match) {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  const [isDisabled, setDisabled] = useState(false);
  const loginuser = useSelector((state) => state.setUserlog);
  const getpageData = useSelector((state) => state.setcatlistData);
  const history = useHistory({ forceRefresh: true });
  const aid = localStorage.getItem("auction_id");
  const [cid, setCid] = useState(loginuser["cid"]);
  const [color, setColor] = useState("#fff");
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [isMinPlayer, setIsMinPlayer] = useState("0");
  const updtoken = useSelector((state) => state.updtoken);

  const { upddata } = useContext(FirebaseContext);
  const isfirsttime = useSelector((state) => state.isfirsttime);
  const getaucpageData = useSelector((state) => state.setactlistData);

  const inputArr = [
    {
      type: "number",
      id: 1,
      value: "",
    },
  ];

  const [addInputField, setAddInputField] = useState([]);

  const addInput = () => {
    setAddInputField((s) => {
      return [
        ...s,
        {
          type: "number",
          id: s.length + 1,
          value: "",
          af:""
        },
      ];
    });
  };
  ////  console.log(addInputField);

  const removeInputField = (i) => {
    setAddInputField((current) => current.filter((input) => input.id !== i));
  };

  // handleChnage for add input field
  // const handleChange = e => {
  //   e.preventDefault();

  //   const index = e.target.id;
  //   setArr(s => {
  //     const newArr = s.slice();
  //     newArr[index].value = e.target.value;

  //     return newArr;
  //   });
  // };

  var savenew = 0;

  const onSubmit = (values) => {
    setDisabled(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
    });
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
      },
    };
    values["clr"] = color;
    values["ismin"] = isMinPlayer;
    values["mincr_n"] = addInputField.length;
    if(addInputField.length>0){

      // const fieldsToRemove=['type','id']
      var finalmincr=addInputField.map(obj => {
        const newObj = {};
        for (const key in obj) {
            newObj['i'] = obj['value'];
            newObj['a'] = obj['af'];
        }
        return newObj;
      });
      values["mincr"] = finalmincr;

    }
    else{
      values["mincr"] = "";

    }
    //  console.log(values)
    DataService.addCategory(values, hdr)
      .then((res) => {
        let response = res.data;
        //  console.log(response);
        toast.dismiss(toastContainerId);

        if (response.success == true) {
          let submitdata = [response.data.new];
          
          let responsedata = {};
          if (getpageData == 0) {
            responsedata = {
              responsedata: { aid: aid, list: [...submitdata] },
            };
          } else {
            responsedata = {
              responsedata: {
                aid: aid,
                list: [...submitdata, ...getpageData.responsedata.list],
              },
            };
          }
          dispatch(catlistData(responsedata));
          toast.success(response.msg, {
            theme: "dark",
            position: "bottom-center",
          });
          if (savenew == 0) {
            history.push(BASE_PATH + "auction-category");
          } else {
            window.scrollTo(0, 0);
            setAddInputField([])
            setColor("#fff")
            setValue("cname", "");
            setValue("plno", "0");
            setValue("minplno", "0");
            setValue("mbid", "0");
            setValue("incrs", "0");
            setValue("resv", "0");
            setValue("hibid", "0");
            setValue("cathibid", "0");
            setValue("clr", "");
            setIsMinPlayer(false)
          }
        } else {
         

          toast.error(response.msg, { theme: "colored" });
        }
        const db = getDatabase();
        //  console.log("values")
        //  console.log(response.data)
        set(ref(db, 'map/info/'+aid), {"type":"3","upd":"1",'id':response.data.new.cid,"detail":{
          "cathibid":values.cathibid,
          "clr":values.clr,
          "cname":values.cname,
          "hibid":values.hibid,
          "incrs":values.incrs,
          "ismin":values.ismin,
          "mbid":values.mbid,
          "minplno":values.minplno,
          "plno":values.plno,
          "resv":values.resv,
          "cid":response.data.new.cid
          
        },"tkn":updtoken});
        setDisabled(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.dismiss(toastContainerId);
        toast.error("Not valid Server Error", { theme: "colored" });
        setDisabled(false);
      });
  };

  const handleSHowColorPicker = () => {
    setShowColorPicker(!showColorPicker);
  };

  useEffect(() => {
    //  console.log("kkk");
    setIsMinPlayer(false)
    setValue("plno", "0");
    setValue("minplno", "0");
    setValue("mbid", "0");
    setValue("incrs", "0");
    setValue("resv", "0");
    setValue("hibid", "0");
    setValue("cathibid", "0");
  }, []);
  useEffect(() => {
    const isFirstMount = localStorage.getItem('isFirstMount');
    //  console.log('isFirstMount')
    //  console.log(isFirstMount)
    if (!isFirstMount) {
      localStorage.setItem('isFirstMount', false);
    } else {
      localStorage.removeItem('isFirstMount');
      history.push('/auction-detail');
    }
  }, [history]);
  const firechange = (datasnap) => {
    if (datasnap.type == "1" && datasnap.upd == "3") {
      if (getaucpageData != 0) {
        const updateitem = getaucpageData.responsedata.list.filter((ele) => ele.aid != datasnap.id)

        let responsedata = {
          responsedata: {
            path: getaucpageData.responsedata.path,
            cid: cid,
            list: updateitem,
          },
        };
        dispatch(actlistData(responsedata));
      }
      history.push(BASE_PATH + 'my-auction')
    }
  }
  useEffect(() => {
    if (upddata !== null) {
      if (upddata !== isfirsttime) {
        firechange(upddata);
        if (upddata.upd == "4") {
          dispatch(setisfirsttime(upddata));
        }
      }
    }
  }, [upddata]);


  const handleFormChange = (index, event) => {
    // //  console.log('aaaaaa');
    // //  console.log(event.target.value)
    let data = [...addInputField];
    data[index]['value'] = event.target.value;
    setAddInputField(data);
  }
  const handleFormChangeAf = (index, event) => {
    let data = [...addInputField];
    data[index]['af'] = event.target.value;
    setAddInputField(data);
  }

  return (
    <>
      <div>
        <Navigationtitle data={match} />

        <div
          id="top-categories"
          className="top-cat-area default-padding bottom-less"
        >
          <div className="container-fluid">
            <div className="row">
              <div id="contact-us" className="reg-area">
                <div className="container-fluid">
                  <div className="row">
                    <div className="reg-items">
                      <div className="col-md-5  reg-form">
                        <form
                          onSubmit={handleSubmit(onSubmit)}
                          action=""
                          autoComplete="off"
                          encType="multipart/form-data"
                        >
                          <div className="row myclass1">
                            <div className="col-md-12 addcat-margtop">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  <label typeof="cname" className="addcat-label">
                                    {" "}
                                    Category Name *{" "}
                                  </label>
                                </div>
                                <div className="col-md-6">
                                  {" "}
                                  <input
                                    className="form-control addcat-input-control"
                                    placeholder="Category Name"
                                    type="text"
                                    {...register("cname", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  />
                                  {errors.cname && (
                                    <p className="text-error">
                                      {errors.cname.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>

                            {/* <div className="col-xs-12 col-md-12 margin-top-14px">
                              <div className="form-group text-box-margin">
                               
                              <div className="col-xs-12 col-sm-9 col-md-10 col-md-offset-2 col-sm-offset-3">
                                 
                                  
                                    <label for="isminchk" className="labelcheck">
                                     Minimum Player Limit?</label>
                                  </div>
                                
                              </div>
                            </div> */}

                            <div className="col-md-12 margin-top-14px margintop-0px">
                              {" "}
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label typeof="plno" className="addcat-label"> Max Players <span className="spansmall">(Per Team)</span> </label>
                                </div>
                                <div className="col-md-4 addcat-margtop">
                                  {" "}
                                  <input
                                    className="form-control addcat-input-control"
                                    placeholder="Max Players"
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    {...register("plno", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  />
                                </div>
                              
                                <div className="col-md-2 addcat-labelcheck ">
                                  {" "}
                                  <input
                                      className="form-control labelcheck  "
                                      type="checkbox"
                                      id="isminchk"
                                      checked={isMinPlayer==1?true:false}
                                      onChange={(e) => {
                                        if (e.target.checked === true) {
                                          setIsMinPlayer("1");
                                        } else {
                                          setIsMinPlayer("0");
                                          setValue('minplno','0')
                                        }
                                      }}
                                    />
                                  <label typeof="minplno" className="minpl-div addcat-label"> Min Players </label>
                                </div>
                                <div className="col-md-4">
                                  {" "}
                                  <input
                                    className="form-control addcat-margtop addcat-input-control"
                                    placeholder="Min Players"
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    disabled={isMinPlayer === "1" ? false : true}
                                    {...register("minplno")}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px addcat-margtop">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label typeof="mbid" className="addcat-label"> Base Bid </label>
                                </div>
                                <div className="col-md-4">
                                  {" "}
                                  <input
                                    className="form-control addcat-input-control"
                                    placeholder="Min Bid"
                                    type="number"
                                    step="any"
                                    onWheel={(e) => e.target.blur()}
                                    {...register("mbid", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px margintop-0px">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  <label typeof="incrs" className="addcat-label"> Increment </label>
                                </div>
                                <div className="col-xs-10 col-md-4 incr-input">
                                  {" "}
                                  <input
                                    className="form-control addcat-input-control"
                                    placeholder="Increment"
                                    type="number"
                                    step="any"
                                    onWheel={(e) => e.target.blur()}
                                    {...register("incrs", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  />
                                </div>
                                <div
                                  className="col-xs-2 col-md-6 add-Input-button addbtn-div addcat-margtop"
                                  onClick={addInput}
                                >
                                  + <span className="helptext">(click to multipal increment)</span>
                                </div>
                              </div>
                            </div>
                            {addInputField && addInputField.map((item, i) => {
                              return (
                                <div id={i}>
                                  <div className="col-md-12 margin-top-14px margintop-0px">
                                    {" "}
                                    <div className="form-group text-box-margin">
                                      <div className="col-md-2">
                                        {" "}
                                        <label
                                          typeof="plno"
                                          className="margin-top-14px margin-incr"
                                        >
                                          {" "}
                                          Increment of{" "}
                                        </label>
                                      </div>
                                      <div className="col-md-4 incraf-control">
                                        {" "}
                                        <input
                                          className="form-control addcat-input-control "
                                          type="number"
                                          step="any"

                                          onWheel={(e) => e.target.blur()}
                                          onInput={(e) => handleFormChange(i, e)}
                                          {...register("mincr_i_"+i, {
                                            required: true,
                                            required: "required field.",
                                          })}
                                        />
                                      </div>
                                      <div className="col-md-2">
                                        {" "}
                                        <label typeof="minplno" className="margin-after"> After </label>
                                      </div>
                                      <div className="col-md-3 incraf-control">
                                        {" "}
                                        <input
                                          className="form-control addcat-input-control"
                                          type="number"
                                          step="any"

                                          onWheel={(e) => e.target.blur()}
                                          onInput={event => handleFormChangeAf(i, event)}

                                          {...register("mincr_a_"+i)}
                                        />
                                      </div>
                                   
                                  <div
                                    className="col-md-2 margin-top-14px add-Input-button margintop-0px addcat-crossbtn "
                                    onClick={() => removeInputField(item.id)}
                                  >
                                    ×
                                  </div>
                                </div>
                                </div>
                                </div>
                              );
                            })}

                            <div className="col-md-12 margin-top-14px addcat-margtop">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  <label typeof="resv" className="addcat-label"> Reserve Bid </label>
                                </div>
                                <div className="col-md-4">
                                  {" "}
                                  <input
                                    className="form-control addcat-input-control"
                                    placeholder="Reserve Bid"
                                    step="any"
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    {...register("resv", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px addcat-margtop">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label typeof="hibid" className="addcat-label"> Highest Bid </label>
                                </div>
                                <div className="col-md-4">
                                  {" "}
                                  <input
                                    className="form-control addcat-input-control"
                                    placeholder="Highest Bid"
                                    type="number"
                                    step="any"

                                    onWheel={(e) => e.target.blur()}
                                    {...register("hibid", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  />
                                </div>
                                <span className="padding-left-16px addcat-label">
                                  per Player
                                </span>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px addcat-margtop">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label typeof="cathibid" className="addcat-label">
                                    {" "}
                                    Category Highest Bid{" "}
                                  </label>
                                </div>
                                <div className="col-md-4">
                                  {" "}
                                  <input
                                    className="form-control addcat-input-control"
                                    placeholder="Category Highest Bid"
                                    type="number"
                                    step="any"
                                    onWheel={(e) => e.target.blur()}
                                    {...register("cathibid", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  />
                                </div>
                                <span className="padding-left-16px addcat-label">
                                  for All Player
                                </span>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px addcat-margtop">
                              <div className="col-md-2">
                                <label className="addcat-label"> Category Color </label>
                              </div>
                              <div className="col-md-4">
                                <div
                                  className="choose-color-div"
                                  onClick={handleSHowColorPicker}
                                >
                                  <div className="choose-color-text ">
                                    Category Color
                                  </div>{" "}
                                  <div
                                    className="circle"
                                    style={{ backgroundColor: color }}
                                  ></div>{" "}
                                </div>
                                {showColorPicker ? (
                                  <div className="choose-picker-div">
                                    <ColorPicker setColor={setColor} />
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                            <div className="col-md-12">
                            <button
                                className="button catadd-btns"
                                onClick={() => (savenew = 1)}
                                type="submit"
                                style={{
                                  borderRadius: "8px",
                                  marginLeft: "16px",
                                }}
                              >
                                SAVE AND ADD NEW
                              </button>
                              <button
                                className="button catadd-btns"
                                onClick={() => (savenew = 0)}
                                type="submit"
                                style={{
                                  borderRadius: "8px",
                                  marginLeft: "16px",
                                }}
                              >
                                ADD CATEGORY
                              </button>
                              
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Addcategory;
